<form [formGroup]="updateForm" matDialogContent>
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput type="text" formControlName="name" />
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Commission Rate %</mat-label>
      <input matInput type="number" formControlName="commissionRate" />
    </mat-form-field>
  </div>
</form>
<div matDialogActions>
  <button
    (click)="update()"
    [disabled]="updateForm.invalid || updateForm.pristine"
    mat-raised-button
    color="primary"
    type="button"
    matDialogClose
  >
    Update
  </button>
  <button mat-button type="button" color="primary" matDialogClose>Cancel</button>
</div>
